'use strict';

import NS from 'src/ns';
import $ from 'jquery';
import forEach from 'lodash/each';
import assign from 'lodash/assign';
import slickCarousel from 'slick-carousel';

class MissionStatement {
  constructor($target) {
    this.$block = $target;
    this.$slider = this.$block.find('.stl-MissionStatement__slider');
    this.ns = '.' + MissionStatement.BEM.block;
  }

  init() {
    this.$slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    });
  }
}

assign(MissionStatement, {
  BEM: {
    block: 'stl-MissionStatement',
    element: {},
    modifier: {}
  },
  create: function(element) {
    const $target = element ? $(element): $('.' + MissionStatement.BEM.block).first();

    if (!$target.length) return;

    new MissionStatement($target).init();
  },
  createAll() {
    let $target = $('.' + MissionStatement.BEM.block);

    if (!$target.length) return;

    forEach($target, (target) => {
      MissionStatement.create(target);
    });
  }
});


export default NS.MissionStatement = MissionStatement;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/block/missionStatement.js